var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose, Type } from 'class-transformer';
import { IsEnum, IsNumber, IsObject, IsOptional } from 'class-validator';
import { TrainingSessionHappinessEnum } from '../enums/training-session-happiness.enum.js';
export class TrainingSessionWellbeeingHistoryDto {
    history;
}
__decorate([
    IsObject(),
    Expose(),
    Type(() => TrainingSessionWellbeeingHistoryItemDto),
    __metadata("design:type", Object)
], TrainingSessionWellbeeingHistoryDto.prototype, "history", void 0);
/**
 * One day's averaged self-assessment. Mood and difficulty are averaged
 * independently — a day is present as soon as *one* of them was rated — so each
 * field is nullable on its own and consumers must skip rather than substitute a
 * zero (0 is a legitimate "sehr schlecht" / "schwer" rating).
 *
 * `difficulty` is deliberately raw: unlike `happiness` there is no derived level
 * on the wire, because this DTO is persisted as JSON on `user_training_session_stats`
 * and a stored bucket label would go stale if the `getDifficultyString` boundaries
 * ever move. Callers derive the level with that shared helper instead.
 */
export class TrainingSessionWellbeeingHistoryItemDto {
    happiness;
    evalMood;
    /**
     * Scale 1–100, bucketed hard ≤33 / perfect 34–66 / easy >66. Optional on the
     * type as well as nullable: rows written before this field existed are only
     * rewritten by the nightly stats cron, so it can be missing entirely.
     */
    difficulty;
}
__decorate([
    IsEnum(TrainingSessionHappinessEnum),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], TrainingSessionWellbeeingHistoryItemDto.prototype, "happiness", void 0);
__decorate([
    IsNumber(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], TrainingSessionWellbeeingHistoryItemDto.prototype, "evalMood", void 0);
__decorate([
    IsNumber(),
    Expose(),
    IsOptional(),
    __metadata("design:type", Object)
], TrainingSessionWellbeeingHistoryItemDto.prototype, "difficulty", void 0);
//# sourceMappingURL=training-session-wellbeeing-history.dto.js.map